const violationRoute = [
  {
    path: '/violation/violation-list',
    name: 'ViolationList',
    authed: 'ViolationList',
    component: () => import('@/views/violation/violationLog/index.vue'),
    meta: {
      tabName: '违规日志管理',
      group: '合规功能',
      icon: 'mdiAlertCircle',
      groupSort: 60,
      title: '违规日志管理',
    },
  },
  {
    path: '/violation/violation-handle',
    name: 'ViolationHandleList',
    authed: 'ViolationHandleList',
    component: () => import('@/views/violation/queryViolation/index.vue'),
    meta: {
      tabName: '违规处理查询',
      group: '合规功能',
      title: '违规处理查询',
    },
  },
  {
    path: '/notification/notification-list',
    name: 'NotificationList',
    authed: 'NotificationList',
    component: () => import('@/views/notification/index.vue'),
    meta: {
      tabName: 'Notification',
      group: '合规功能',
      title: '',
      groupSort: 50,
    },
  },
]

export default violationRoute
